import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pl-3",
  style: {"font-size":"14px"}
}

import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputTimesForm',
  props: {
    title: {},
    maxlength: {},
    windowInnerWidth: {},
    modelValue: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;


const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col, { cols: "1" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(props.title), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, {
      cols: __props.windowInnerWidth > 800 ? 3 : 5,
      style: _normalizeStyle(__props.windowInnerWidth > 800 ? '' : 'margin-right: 23px;')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.hours,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.hours) = $event)),
          suffix: _unref(i18n).global.t('pages.operationOffices.hours'),
          class: "mt-0",
          density: "compact",
          min: 0,
          maxlength: props.maxlength?.hours,
          "error-messages": __props.errors?.hours
        }, null, 8, ["modelValue", "suffix", "maxlength", "error-messages"])
      ]),
      _: 1
    }, 8, ["cols", "style"]),
    _createVNode(_component_v_col, {
      cols: __props.windowInnerWidth > 800 ? 3 : 5
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.minutes,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.minutes) = $event)),
          suffix: _unref(i18n).global.t('pages.operationOffices.minutes'),
          class: "mt-0",
          density: "compact",
          min: 0,
          maxlength: props.maxlength?.minutes,
          "error-messages": __props.errors?.minutes
        }, null, 8, ["modelValue", "suffix", "maxlength", "error-messages"])
      ]),
      _: 1
    }, 8, ["cols"])
  ], 64))
}
}

})